export default __webpack_public_path__ + "static/media/pro-camp-certificate.a8df1ca4.png";